module.exports = __webpack_public_path__ + "img/gk-guide-zhengce-img2.44a2724c.png";